module.exports = __webpack_public_path__ + "img/capitole.634c1957.jpg";